import openReasignModal from './openReasignModal';
import resetReasignForm from './resetReasignForm';

export default () => (dispatch) => {
    dispatch(resetReasignForm());
    dispatch(openReasignModal(false));
};
